import exportFromJSON from './exportFromJSON.js';
export default exportFromJSON;
